import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Docs-Node" }
const _hoisted_2 = { class: "mb-16" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " / ", -1 /* HOISTED */)
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NodeExamples = _resolveComponent("NodeExamples")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "no-underline",
        to: _ctx.docsRoute(_ctx.DocsRoute.NODES)
      }, {
        default: _withCtx(() => [
          _createTextVNode("Nodes")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _hoisted_3,
      _createVNode(_component_router_link, {
        class: "no-underline",
        to: _ctx.docsNodeContext(_ctx.context)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.context.toUpperCase()), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createElementVNode("span", null, " / " + _toDisplayString(_ctx.type), 1 /* TEXT */)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        ref: "descriptionElement",
        innerHTML: _ctx.description
      }, null, 8 /* PROPS */, _hoisted_4),
      _createCommentVNode(" <div v-if=\"componentGenerator\">\n\t\t\t\t<MDXProvider :components=\"MDX_COMPONENTS\"><component :is=\"componentGenerator\" /></MDXProvider>\n\t\t\t</div> "),
      _createVNode(_component_NodeExamples, {
        context: _ctx.context,
        type: _ctx.type
      }, null, 8 /* PROPS */, ["context", "type"])
    ])
  ]))
}